var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Dropdown from '../dropdown';
import { Styled } from './style';
var AppStoreCategorySidebar = /** @class */ (function (_super) {
    __extends(AppStoreCategorySidebar, _super);
    function AppStoreCategorySidebar(props) {
        return _super.call(this, props) || this;
    }
    AppStoreCategorySidebar.prototype.onItemClick = function (type, value) {
        if (this.props.onItemClick) {
            this.props.onItemClick(type, value);
        }
    };
    AppStoreCategorySidebar.prototype.categories = function (mobile) {
        var _this = this;
        var _a;
        var result = (_a = this.props.categories) === null || _a === void 0 ? void 0 : _a.map(function (category) {
            if (mobile) {
                return { key: category.id, text: category.name, value: category.id };
            }
            return (React.createElement("li", { key: category.id, className: "item" },
                React.createElement("a", { onClick: _this.onItemClick.bind(_this, 'category', category.id), className: "link " + (_this.props.selectedCategory && _this.props.selectedCategory.includes(category.id) ? 'selected' : '') }, category.name)));
        });
        if (result && !mobile) {
            result.unshift(React.createElement("li", { key: "newapps", className: "item" },
                React.createElement("span", { className: "name" },
                    React.createElement("a", { onClick: this.onItemClick.bind(this, 'category', 'all'), className: "link " + (!this.props.selectedCategory || !this.props.selectedCategory.length ? 'selected' : '') }, "All Apps"),
                    this.props.newcount && React.createElement("i", { className: "new" }, this.props.newcount))));
        }
        return result;
    };
    AppStoreCategorySidebar.prototype.third = function (mobile) {
        var _this = this;
        return (this.props.third &&
            this.props.third.map(function (third) {
                if (mobile) {
                    return { key: third.id, text: third.name, value: third.id };
                }
                return (React.createElement("li", { key: third.id, className: "item" },
                    React.createElement("a", { onClick: _this.onItemClick.bind(_this, 'third', third.id), className: "link " + (_this.props.selectedThird && _this.props.selectedThird.includes(third.id) ? 'selected' : '') }, third.name)));
            }));
    };
    AppStoreCategorySidebar.prototype.features = function (mobile) {
        var _this = this;
        return (this.props.features &&
            this.props.features.map(function (feature) {
                if (mobile) {
                    return { key: feature.id, text: feature.name, value: feature.id };
                }
                return (React.createElement("li", { key: feature.id, className: "item" },
                    React.createElement("a", { onClick: _this.onItemClick.bind(_this, 'feature', feature.id), className: "link " + (_this.props.selectedFeature && _this.props.selectedFeature.includes(feature.id) ? 'selected' : '') }, feature.name)));
            }));
    };
    AppStoreCategorySidebar.prototype.wrapper = function (title, type, data) {
        var _this = this;
        var list = data.bind(this)();
        if (!list || !list.length) {
            return null;
        }
        return (React.createElement("section", { className: "section" },
            React.createElement("h3", { className: "title" }, title),
            React.createElement("ul", { className: "list" }, list),
            React.createElement(Dropdown, { inline: true, className: "dropper", text: title, options: data.bind(this)(true), onChange: function (e, _a) {
                    var value = _a.value;
                    _this.onItemClick(type, value);
                } })));
    };
    AppStoreCategorySidebar.prototype.render = function () {
        return (React.createElement(Styled, { className: "category-sidebar" },
            this.wrapper('Categories', 'category', this.categories),
            this.wrapper('3rd Party Subscriptions', 'third', this.third),
            this.wrapper('Features', 'feature', this.features)));
    };
    return AppStoreCategorySidebar;
}(React.Component));
export default AppStoreCategorySidebar;
//# sourceMappingURL=index.js.map